import checkBuildVersion from './utils/check-build-version'

// 生产环境统一使用 www 域名，保留路径、查询参数和 hash。
if (process.env.NODE_ENV === 'production' && !window.location.hostname.startsWith('www.')) {
  const url = new URL(window.location.href)
  url.hostname = 'www.' + url.hostname
  window.location.replace(url.href)
} else {
  checkBuildVersion().then(() => {
    require('./bootstrap')
  })
}



// WEBPACK FOOTER //
// ./src/main.js